
import cacaAoTesouroGlobalCheck from './CacaAoTesouroGlobalCheckReducer';


export default cacaAoTesouroGlobalCheck;
